import {
    DIALOG_BTN1,
    DIALOG_BTN2,
    DIALOG_CLOSE,
    DIALOG_OPEN,
    DIALOG_WAIT
} from "../../constants/action-types";

import initialState from "../initialState";

const dialog = (state = initialState.msgDialog, action) => {
    switch (action.type) {
        case DIALOG_BTN1:
            return { 
                ...state, 
                dialogState: 2,
                dialogBtn: 1
            }

        case DIALOG_BTN2:
            return { 
                ...state, 
                dialogState: 2,
                dialogBtn: 2
            }

        case DIALOG_OPEN:
            return {
                ...state,
                dialogState: 1,

                dialogHeader: action.payload.header,
                dialogBody: action.payload.body,
                dialogBtn1: action.payload.btn1,
                dialogBtn1Txt: action.payload.btn1Txt,
                dialogBtn2: action.payload.btn2,
                dialogBtn2Txt: action.payload.btn2Txt,
                dialogOpen: true,
                dialogPayload: action.payload.payload
            }

        case DIALOG_CLOSE:
            if (state.dialogState === 0) {
                return state;
            }

            return { 
                ...state, 
                dialogBody: '',
                dialogBtn: 0,
                dialogBtn1: () => {},
                dialogBtn1Txt: '',
                dialogBtn2: () => {},
                dialogBtn2Txt: '',
                dialogHeader: '',
                dialogOpen: false
            }

        case DIALOG_WAIT:
            if (state.dialogState === 3) {
                return state;
            }
            return { ...state, dialogState: 3 }

        default:
            return state;
    }
}

export default dialog;


// WEBPACK FOOTER //
// ./src/store/reducers/msgDialog.js